/**
 * ApplicationUtilities.js
 * - handler for the application helper function
 * @since March 26, 2019
 * @author 
 * - Aron Joshua Bagtas <aaron@qstrike.com>
 *
 * Requirements:
 * - jQuery
 * - Mustache
 *
 * Usage:
 *  Helper for application(Names, Letters, Logo) panel 
 */

$(function() {
    ub.funcs.initializer = function () {
        // slider scale
        var scaleSliders = document.getElementsByClassName('slider-control-scale');
        $(scaleSliders).each(function(i) {
            var dataId = $(this).data('id');
            var _settingsObject = ub.funcs.getApplicationSettings(dataId)
            var _applicationType = _settingsObject.application_type;
            ub.funcs.initScalePanel(scaleSliders[i], _settingsObject, _applicationType);
            if (! $(this).hasClass('init')) {
                // Marker that applications has been initialized
                $(this).addClass('init')
            }
            $(this).find('.noUi-value-large').first().html('Small');
            $(this).find('.noUi-value-large').last().html('Large');
        });

        // slider move X
        var moveXSliders = document.getElementsByClassName('slider-control-move-x');
        $(moveXSliders).each(function(i) {
            var dataId = $(this).attr('data-id');
            var _settingsObject = ub.funcs.getApplicationSettings(dataId)
            var _applicationType = _settingsObject.application_type;
            ub.funcs.initMovePanelX(moveXSliders[i],_settingsObject, _applicationType);
            if (! $(this).hasClass('init')) {
                // Marker that applications has been initialized
                $(this).addClass('init')
            }
            $(this).find('.noUi-value-large').first().html('Left');
            $(this).find('.noUi-value-large').last().html('Right');
        });

        // slider move Y
        var moveYSliders = document.getElementsByClassName('slider-control-move-y');
        $(moveYSliders).each(function(i) {
            var dataId = $(this).attr('data-id');
            var _settingsObject = ub.funcs.getApplicationSettings(dataId)
            var _applicationType = _settingsObject.application_type;
            ub.funcs.initMovePanelY(moveYSliders[i],_settingsObject, _applicationType);
            if (! $(this).hasClass('init')) {
                // Marker that applications has been initialized
                $(this).addClass('init')
            }
            $(this).find('.noUi-value-large').first().html('Up');
            $(this).find('.noUi-value-large').last().html('Down');
        });

        // slider rotate
        var rotateSliders = document.getElementsByClassName('slider-control-rotate');
        $(rotateSliders).each(function(i) {
            var dataId = $(this).attr('data-id');
            var _settingsObject = ub.funcs.getApplicationSettings(dataId)
            var _applicationType = _settingsObject.application_type;
            ub.funcs.initRotatePanel(rotateSliders[i], _settingsObject, _applicationType);
            if (! $(this).hasClass('init')) {
                // Marker that applications has been initialized
                $(this).addClass('init')
            }
        });

        // add class active to all first tab of color selection tab
        var colorFirstTab = document.getElementsByClassName('color-selection-tab');
        $(colorFirstTab).each(function(){
            $(this).find('li:first-child').addClass('active');
        });
        var colorFirstTabContent = document.getElementsByClassName('tab-content');
        $(colorFirstTabContent).each(function(){
            $(this).find('.tab-pane:first-child').addClass('in active');
        });

        // add applications opt
        var selectNewAppOptions = document.getElementsByClassName('addApplicationsOpts');
        $(selectNewAppOptions).each(function(){
            $(this).find('div > button').removeClass('active');
            $(this).find('div > button:first-of-type').addClass('active');
            $(this).find('div > button:nth-of-type(odd)').addClass('pull-left');
            $(this).find('div > button:nth-of-type(even)').addClass('pull-right');
        });
    };

    ub.funcs.initRotatePanel = function (element, _settingsObject, applicationType) {
        if ($(element).hasClass('init')) { return; }
        var _flag = false;
        var _multiplier = 100;
        if (applicationType !== "mascot") {
            _multiplier = 10;
        }

        var _v = ub.funcs.getPrimaryView(_settingsObject.application);
        var rotation = ub.objects[_v + '_view']['objects_' + _settingsObject.code].rotation;
        var computedRotation = (rotation / Math.PI) * 180.00;

        var _start = 0;
        var _start = (computedRotation * 5) / 18;
        if (_start < 0 && _start > -60) {
            _start += 60 + 40;
        }

        $(element).roundSlider({
            sliderType: "min-range",
            handleShape: "round",
            width: 15,
            radius: 85,
            value: _start,
            startAngle: 90,

            drag: function (args) {
                if (!_flag) { _flag = true; return;}
                ub.funcs.updateRotationViaSlider(_settingsObject, args.value);
            }
        });
    };

    ub.funcs.initScalePanel = function (element, _settingsObject, applicationType) {
        if ($(element).hasClass('init')) { return; }
        var _flag = false;
        var _multiplier;
        var _start;
        if (TextShapeCore.utilities.isTextShape(_settingsObject.code)) {
            _multiplier = 20;
        } else if (applicationType !== "mascot") {
            _multiplier = 10;
        } else {
            _multiplier = 100;
        }



        var _v = ub.funcs.getPrimaryView(_settingsObject.application);
        var scaleX = ub.objects[_v + '_view']['objects_' + _settingsObject.code].scale.x;
        // Check if Scale is Existing
        if (typeof scaleX !== "undefined") {
            _start = (_multiplier * scaleX) / 3;
        } else {
            _start = (_multiplier * 1) / 3;
            ub.utilities.info("Cannot find object " + _settingsObject.code);
        }
        
        var slider = _start * ub.current_material.material.one_inch_in_px / 2;
        

        noUiSlider.create(element, {
            animate: true,
            animationDuration: 300,
            start: slider,
            range: {
                min: 1,
                max: 100,
            },
            tooltips: true,
            format: wNumb({
                decimals: 0
            }),
            pips: {
                mode: 'steps',
                stepped: true,
                density: 4
            }
        });

        element.noUiSlider.on('update', function (values, handle) {
            if (!_flag) { _flag = true; return;}
            var _value = values[0];
            var scale = _value * 2 / ub.current_material.material.one_inch_in_px;
            ub.funcs.updateScaleViaSlider(_settingsObject, scale);
        });
    };

    ub.funcs.initMovePanelX = function (element, _settingsObject, applicationType) {
        if ($(element).hasClass('init')) { return; }
        var _flag = false;
        var _multiplier = 100;
        if (applicationType !== "mascot") {
            _multiplier = 10;
        }

        var _v = ub.funcs.getPrimaryView(_settingsObject.application);
        var _startX = ub.objects[_v + '_view']['objects_' + _settingsObject.code].position.x;

        _startX = _startX / ub.dimensions.width * 100;

        if (typeof element.noUiSlider === "object") {
            element.noUiSlider.set(_startX);
            return;
        }

        noUiSlider.create(element, {
            animate: true,
            animationDuration: 300,
            start: _startX,
            range: {
                min: 1,
                max: 100,
            },
            tooltips: true,
            format: wNumb({
                decimals: 0
            }),
            pips: {
                mode: 'steps',
                stepped: true,
                density: 4
            }
        });

        element.noUiSlider.on('update', function (values, handle) {
            if (!_flag) { _flag = true; return;}
            var _value = values[0];
            ub.funcs.updatePositionViaSlider(_settingsObject, _value, 'x');
        });
    };

    ub.funcs.initMovePanelY = function (element, _settingsObject, applicationType) {
        if ($(element).hasClass('init')) { return; }
        var _flag = false;
        var _multiplier = 100;
        if (applicationType !== "mascot") {
            _multiplier = 10;
        }

        var _v = ub.funcs.getPrimaryView(_settingsObject.application);
        var _startY = ub.objects[_v + '_view']['objects_' + _settingsObject.code].position.y;

        _startY = _startY / ub.dimensions.height * 100;

        if (typeof element.noUiSlider === "object") {
            element.noUiSlider.set(_startY);
            return;
        }

        noUiSlider.create(element, {
            animate: true,
            animationDuration: 300,
            start: _startY,
            range: {
                min: 1,
                max: 100,
            },
            tooltips: true,
            format: wNumb({
                decimals: 0
            }),
            pips: {
                mode: 'steps',
                stepped: true,
                density: 4
            }
        });

        element.noUiSlider.on('update', function (values, handle) {
            if (!_flag) { _flag = true; return;}
            var _value = values[0];
            ub.funcs.updatePositionViaSlider(_settingsObject, _value, 'y');
        });
    };

    ub.funcs.isFlippedApplication = function (code) {
        var _applicationObject = ub.funcs.getApplicationSettings(code);
        var flipped = _applicationObject.application.views[0].application.flip;
        if (flipped === 1) {
            return true;
        } else {
            return false;
        }
    };

    // Get available size for application in a tackle twill uniform
    ub.funcs.getRichardsonApplicationSizes = function(_settingsObject) {
        var _applicationType = _settingsObject.application_type;
        var _title = _applicationType.toTitleCase();
        var _sampleText = _settingsObject.text;
        var _sizes;
        var _uniformCategory = ub.current_material.material.uniform_category
        var _alias = ub.data.sportAliases.getAlias(_uniformCategory);
        var _isFreeFormEnabled = ub.funcs.isFreeFormToolEnabled(_settingsObject.code);


        if (_uniformCategory === "Football") {
            _sizes = ub.funcs.getApplicationSizes(_applicationType);
        } else if (ub.current_material.material.uniform_category === "Baseball") {
            _sizes = ub.funcs.getApplicationSizes(_applicationType, 'baseball');
        } else if (_uniformCategory !== "Football" && _uniformCategory !== "Wrestling" && typeof _alias !== "undefined") {
            _sizes = ub.funcs.getApplicationSizes(_applicationType, _alias.alias);
        } else {
            ub.utilities.warn('no sizes setting defaulting to generic');
            _sizes = ub.funcs.getApplicationSizes(_applicationType);
        }

        // New application sizes values from backend
        var _sizesFromConfig = ub.data.applicationSizes.getConfiguration(_applicationType, _settingsObject.code);

        if (typeof _sizesFromConfig !== "undefined") {
            // Debug Info
            if (ub.data.consumeApplicationSizes.isValid(ub.config.sport)) {
                // add sort for sizes
                _sizesSorted = _.sortBy(_sizesFromConfig.sizes, function (obj) {
                    return parseFloat(obj.size)
                });
                _sizesFromConfig.sizes = _sizesSorted;

                _sizes = _sizesFromConfig;
            }

        } else {
            if (ub.data.consumeApplicationSizes.isValid(ub.config.sport)) {
                ub.utilities.info('Application Type: ' + _applicationType);
                ub.utilities.info('alias: ' + _alias.alias);

                ub.utilities.error(ub.config.sport + " - " + _applicationType + " - " + _settingsObject.code + " don't have application sizes settings on the backend.");
            }
        }

        return _sizes;
    }

    ub.funcs.renderStockMascot = function (_settingsObject) {
        var objCustom, template, renderTemplate;

        if (_settingsObject.application_type === "mascot") {
            objCustom = {
                thumbnail: _settingsObject.mascot.icon,
                code: _settingsObject.code,
                perspective: _settingsObject.application.views[0].perspective,
                name: _settingsObject.mascot.name,
                application_type: _settingsObject.application_type,
                logo_type: _settingsObject.logo_type,
            };
            // Template         
            template = document.getElementById("m-mascot-information-logo").innerHTML;
            renderTemplate = Mustache.render(template, objCustom);

            $(".modifier_main_container .logo-details-container").html("");
            $(".modifier_main_container .logo-details-container").html(renderTemplate);
        } else {
            if (typeof _settingsObject.embellishment !== "undefined") {
                var designDetails = _settingsObject.embellishment.design_details;

                Inksoft.funcs.checkColorConflict(designDetails, function(hasConflict, colors) {
                    if (hasConflict) {
                        var renderTemplate = Inksoft.funcs.renderConflictingColors(colors, _settingsObject.code);
                        $(".modifier_main_container .logo-details-container").html("");
                        $(".modifier_main_container .logo-details-container").html(renderTemplate);

                        Inksoft.funcs.initEvents();
                    } else {
                        ub.funcs.renderEmbellishment(_settingsObject);
                    }
                });
            }
        }

        $(".logo-type-container .btn-selection-choice.uk-active").removeClass("uk-active");
        $(".logo-type-container .btn-selection-choice[data-type='"+ _settingsObject.logo_type +"']").addClass("uk-active");
        $("#primary_options_container .location-add-remove-container[data-perspective='" + _settingsObject.application.views[0].perspective + "']").html("");
        $("#primary_options_container .location-add-remove-container[data-perspective='" + _settingsObject.application.views[0].perspective + "']")
            .html('<a href="#" class="removeMascot en-disable-me fc-red fc-italic" data-application-code="'+ _settingsObject.code +'">(remove)</a>');
        
        MascotPanel.events.disableButtonWhenAllSelected(_settingsObject);
        
        if (ub.funcs.isSocks()) {
            MascotPanel.events.disableOtherButtonOnSocks(_settingsObject);
        }
    }

    ub.funcs.renderEmbellishment = function(_settingsObject) {
        var design_id = "";
        var design_name = "";
        var design_image = "";
        var design_svg = "";

        if (typeof _settingsObject.embellishment !== "undefined") {
            design_id = _settingsObject.embellishment.design_id;
            design_name = typeof _settingsObject.embellishment.name !== "undefined" ? _settingsObject.embellishment.name : _settingsObject.embellishment.design_name;
            design_image = _settingsObject.embellishment.png_filename;
            design_svg = _settingsObject.embellishment.svg_filename;
        
            if (typeof design_image !== "undefined" && design_image !== "") {
                ub.utilities.trimPngFile(design_image, function(thumbnail) {
                    objCustom = {
                        thumbnail: thumbnail,
                        application_type: _settingsObject.application_type,
                        logo_type: _settingsObject.logo_type,
                        code: _settingsObject.code,
                        perspective: _settingsObject.application.views[0].perspective,
                        name: design_name,
                        viewArtDetails: ub.config.host + '/utilities/preview-logo-information/' + design_id,
                        viewPrint: design_svg,
                        flip: ub.funcs.isFlippedApplication(_settingsObject.code) ? "uk-active" : "",
                        design_id: design_id,
                        isCustom: _settingsObject.logo_type === "custom" ? true: false
                    };
                    // Template
                    template = document.getElementById("m-mascot-information").innerHTML;
                    renderTemplate = Mustache.render(template, objCustom);
    
                    $(".modifier_main_container .logo-details-container").html("");
                    $(".modifier_main_container .logo-details-container").html(renderTemplate);
                });
            } else {
                ub.utilities.error("Missing stock logo thumbnails.")
            }
        }
    }

    ub.funcs.afterRemoveStockLogo = function(settingsObj) {
        $("#primary_options_container .logo-location-container .btn-selection-choice[data-perspective='" + settingsObj.application.views[0].perspective + "']").removeClass("selected");
        $("#primary_options_container .logo-location-container .btn-selection-choice[data-perspective='" + settingsObj.application.views[0].perspective + "']").removeClass("uk-active");
        
        $(".modifier_main_container .logo-details-container").html("");
        $("#primary_options_container .location-add-remove-container[data-perspective='" + settingsObj.application.views[0].perspective + "']").html("");
        $("#primary_options_container .logo-type-container button.btn-selection-choice").removeClass("uk-disabled");
    }
});